(function () {
    'use strict';

    angular.module('user')
        .controller('ClientCreateController', ClientCreateController);

    ClientCreateController.$inject = ['$state', 'clientDataSrvc', 'notificationSrvc', 'clientMessagesConst', 'companyLocalizationConst', 'errorNotificationSrvc'];

    function ClientCreateController($state, clientDataSrvc, notificationSrvc, clientMessagesConst, companyLocalizationConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            user: {
                email: [],
                password: [],
                password2: [],
                first_name: [],
                last_name: []
            },
            telephone: [],
            telephone_2: [],
            company_name: [],
            company_name_2: [],
            tax_id: [],
            address: [],
            address_2: [],
            building_number: [],
            building_number_2: [],
            suite_number: [],
            suite_number_2: [],
            city: [],
            city_2: [],
            zip_code: [],
            zip_code_2: [],
            country: [],
            country_2: [],
            company_localization: [],
            main_account: [],
            non_field_errors: []
        };

        self.clientData = {
            user: {
                email: '',
                password: '',
                password2: '',
                first_name: '',
                last_name: ''
            },
            telephone: '',
            telephone_2: '',
            company_name: '',
            company_name_2: '',
            tax_id: '',
            address: '',
            address_2: '',
            building_number: '',
            building_number_2: '',
            suite_number: '',
            suite_number_2: '',
            city: '',
            city_2: '',
            zip_code: '',
            zip_code_2: '',
            country: '',
            country_2: '',
            company_localization: '',
            main_account: null
        };

        self.companyLocalizations = companyLocalizationConst;
        self.clientOptions = [];

        self.createClient = createClient;
        self.onClientSearch = onClientSearch;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getClientOptions();
        }

        function createClient() {
            clientDataSrvc.create(
                self.clientData
            ).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", clientMessagesConst.add);
                    $state.go('layout.client.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function getClientOptions() {
            return clientDataSrvc.getOptions().$promise.then(
                function(response) {
                    self.clientOptions = response.results;

                    return response;
                }
            );
        }

        function onClientSearch(params) {
            if (!params) {
                params = {};
            }
            return clientDataSrvc.getOptions(
                params
            ).$promise;
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
